module.exports = __webpack_public_path__ + "static/media/7sinif.yt.mat.2.f2809a1b.jpg";